import { FormattedMessage } from 'react-intl';
import { ObjectWithId } from '@synergy/models';
import { padZeroLeft } from '@synergy/utils';

import { BaseAutocompleteSuggestionType } from '../../../../common/components/autocomplete-list/pool-autocomplete-list';
import { PoolFormAutocompleteList } from '../../../../common/components/abstract/form-autocomplete-list';

export interface CountryAutocomplete extends ObjectWithId {
    code: string;
    name: string;
}

export interface PartialCountry extends BaseAutocompleteSuggestionType, Pick<CountryAutocomplete, 'name'> {}

export class CountryAutocompleteList extends PoolFormAutocompleteList<CountryAutocomplete, PartialCountry> {
    public label = (<FormattedMessage id="app.common.country" />);
    public getDisplayValue = (country: CountryAutocomplete) => {
        return country.name;
    };
    public getSuggestionValue = (suggestion: PartialCountry) => suggestion?.name;
    public getPartial = (items: CountryAutocomplete[]): PartialCountry[] => {
        return items.map(country => {
            return {
                id: padZeroLeft(country.id, 5),
                name: country.name,
            };
        });
    };
}
